import { lazy } from "react";

const Dashboard = lazy(() => import("../../pages/User/Dashboard"));
const Course = lazy(() => import("../../pages/User/Courses"));
const Settings = lazy(() => import("../../pages/User/Settings"));
const Annoucement = lazy(() => import("../../pages/User/Annoucement"));
const Survey = lazy(() => import("../../pages/Survey"));

export interface Route {
  name: string;
  path: string;
  component: any;
  protected: boolean;
}

export const protectedRoute: Route[] = [
  {
    name: "Dashboard",
    path: "/dashboard",
    component: Dashboard,
    protected: true,
  },
  {
    name: "Learning",
    path: "/my-learning",
    component: Course,
    protected: true,
  },
  {
    name: "Notification",
    path: "/announcement",
    component: Annoucement,
    protected: true,
  },
  {
    name: "Settings",
    path: "/settings",
    component: Settings,
    protected: true,
  },
  {
    name: "Survey",
    path: "/surveys/:id",
    component: Survey,
    protected: true,
  },
];
